export enum SizeCalculation {
  Amount = 'amount',
  PercentOfWall = 'percent-of-wall',
}
